import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Fab, Tooltip } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';

class FormNextButton extends PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        classes: PropTypes.object.isRequired,
        sendFunc: PropTypes.func.isRequired
    };

    static defaultProps = {
        disabled: false
    };

    render() {
        const { sendFunc, classes, disabled } = this.props;

        return (
            <div>
                <Tooltip title={Translator.translate('general.next')} placement="top">
                    <span>
                        <Fab
                            disabled={disabled}
                            aria-label={Translator.translate('general.next')}
                            className={classes.btn}
                            size="small"
                            onClick={sendFunc}
                        >
                            <ArrowForward className={classes.icon} />
                        </Fab>
                    </span>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    btn: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        marginLeft: 10,
        minHeight: 30,
        minWidth: 30
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    }
});

export default withStyles(styles, { withTheme: true })(FormNextButton);



// WEBPACK FOOTER //
// ./data/components/FormNextButton.js